const initialState = {
  paymentData: {
    loading: false,
    data: null,
    error: null
  },
  paymentDataCuotas: {
    loading: false,
    data: null,
    error: null
  },
  userData:{
    loading: false,
    data: null,
    error: null
  },
  programa:{
    loading: false,
    data: null,
    error: null
  },
  mpPreference: {
    loading: false,
    data: null,
    error: null
  }
};

const PaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SEND_PAYMENT_DATA_REQUEST':
      return {
        ...state,
        paymentData: {
          ...state.paymentData,
          loading: true,
          error: null
        }
      };

    case 'SEND_PAYMENT_DATA_SUCCESS':
      return {
        ...state,
        paymentData: {
          ...state.paymentData,
          loading: false,
          data: action.payload,
          error: null
        }
      };

    case 'SEND_PAYMENT_DATA_FAIL':
      return {
        ...state,
        paymentData: {
          ...state.paymentData,
          loading: false,
          error: action.payload
        }
      };

      case 'GET_USER_DATA_REQUEST':
        return {
          ...state,
          userData: {
            ...state.userData,
            loading: true,
            error: null
          }
        };
  
      case 'GET_USER_DATA_SUCCESS':
        return {
          ...state,
          userData: {
            ...state.userData,
            loading: false,
            data: action.payload,
            error: null
          }
        };
  
      case 'GET_USER_DATA_FAIL':
        return {
          ...state,
          userData: {
            ...state.userData,
            loading: false,
            error: action.payload
          }
        };

      
      case 'SEND_PAYMENT_CUOTAS_DATA_REQUEST':
      return {
        ...state,
        paymentDataCuotas: {
          ...state.paymentDataCuotas,
          loading: true,
          error: null
        }
      };

    case 'SEND_PAYMENT_CUOTAS_DATA_SUCCESS':
      return {
        ...state,
        paymentDataCuotas: {
          ...state.paymentDataCuotas,
          loading: false,
          data: action.payload,
          error: null
        }
      };

    case 'SEND_PAYMENT_CUOTAS_DATA_FAIL':
      return {
        ...state,
        paymentDataCuotas: {
          ...state.paymentDataCuotas,
          loading: false,
          error: action.payload
        }
      };

    case 'GET_PROGRAMA_DESCRIPCION_REQUEST':
      return {
        ...state,
        programa: {
          ...state.programa,
          loading: true,
          error: null
        }
      };

    case 'GET_PROGRAMA_DESCRIPCION_SUCCESS':
      return {
        ...state,
        programa: {
          ...state.programa,
          loading: false,
          data: action.payload,
          error: null
        }
      };

    case 'GET_PROGRAMA_DESCRIPCION_FAIL':
      return {
        ...state,
        programa: {
          ...state.programa,
          loading: false,
          error: action.payload
        }
      };

      case 'MP_CREATE_PREFERENCE_REQUEST':
        return {
          ...state,
          mpPreference: {
            ...state.mpPreference,
            loading: true,
            error: null,
            data: null
          }
        };
      case 'MP_CREATE_PREFERENCE_SUCCESS':
        return {
          ...state,
          mpPreference: {
            ...state.mpPreference,
            loading: false,
            data: action.payload,
            error: null
          }
        };
      case 'MP_CREATE_PREFERENCE_FAIL':
        return {
          ...state,
          mpPreference: {
            ...state.mpPreference,
            loading: false,
            error: action.payload
          }
        };
      
    default:
      return state;
  }
};

export default PaymentReducer; 